import React from "react";
import Lottie from "lottie-react";
import { isReactNativeWebView } from '../../hybridApp/helpers';

// Hybrid Loader (Native look)
import KeellsLogo from "../../assets/hybridApp/images/keells-logo-loader.png";
import TopLoaderAnim from "../../assets/hybridApp/lottie/Indikator_1.json";
import "./loadingScreen.scss";

// Web Loader Assets
import cube1 from "../../assets/img/loader/cube-1.jpg";
import cube2 from "../../assets/img/loader/cube-2.jpg";
import cube3 from "../../assets/img/loader/cube-3.jpg";
import cube4 from "../../assets/img/loader/cube-4.jpg";
import cube5 from "../../assets/img/loader/cube-5.jpg";
import cube6 from "../../assets/img/loader/cube-6.jpg";
import cube7 from "../../assets/img/loader/cube-7.jpg";
import cube8 from "../../assets/img/loader/cube-8.jpg";
import cube9 from "../../assets/img/loader/cube-9.jpg";

const LoadingScreen = (props) => {
    const isHybridApp = isReactNativeWebView();

    // Hide completely if not visible
    if (!props.isVisible) return null;

    // --------------------------------------------------------------------------
    // Hybrid Loader (Native Feel)
    // --------------------------------------------------------------------------
    if (isHybridApp) {
        return (
            <div className="loading-screen-container">
                <div className="lottie-top-bar">
                    <Lottie animationData={TopLoaderAnim} loop autoplay />
                </div>
                <img src={KeellsLogo} alt="Keells Logo" className="keells-logo" />
            </div>
        );
    }

    // --------------------------------------------------------------------------
    // Web Loader (Existing cube-style)
    // --------------------------------------------------------------------------
    return (
        <div className="full-width-div">
            <div className="sk-cube-grid" style={{ height: 100, width: 100 }}>
                <img src={cube1} className="sk-cube sk-cube1" alt="cube1" />
                <img src={cube2} className="sk-cube sk-cube2" alt="cube2" />
                <img src={cube3} className="sk-cube sk-cube3" alt="cube3" />
                <img src={cube4} className="sk-cube sk-cube4" alt="cube4" />
                <img src={cube5} className="sk-cube sk-cube5" alt="cube5" />
                <img src={cube6} className="sk-cube sk-cube6" alt="cube6" />
                <img src={cube7} className="sk-cube sk-cube7" alt="cube7" />
                <img src={cube8} className="sk-cube sk-cube8" alt="cube8" />
                <img src={cube9} className="sk-cube sk-cube9" alt="cube9" />
            </div>
        </div>
    );
};

export default LoadingScreen;
